import { render } from "./ColisListe.vue?vue&type=template&id=514b6a02&scoped=true&ts=true"
import script from "./ColisListe.vue?vue&type=script&lang=ts"
export * from "./ColisListe.vue?vue&type=script&lang=ts"

import "./ColisListe.vue?vue&type=style&index=0&id=514b6a02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514b6a02"]])

export default __exports__